export const enum CompaniesEnum {
  Lyft = 27,
  SimplyMma = 176,
  Uber = 473,
  None = 4,
}

export const CompaniesList = [
  {
    description: 'Lyft',
    id: CompaniesEnum.Lyft,
    url: 'assets/images/LyftIMG.png',
  },
  {
    description: 'Uber',
    id: CompaniesEnum.Uber,
    url: 'assets/images/UberIMG.png',
  }
]



// WEBPACK FOOTER //
// ./src/app/core/enums/companies.enum.ts